import React from "react";
import ExhibitorDashboardNavbar from "./exhibitor_dashboard/ExhibitorDashboardNavbar";
import Footer from "../superAdmin/footer/Footer";

const ExhibitorLayout = ({ children, title, count, toolbarLeft, toolbarRight }) => {
  return (
    <div className="crm-layout">
      <ExhibitorDashboardNavbar />
      <div className="crm-main-content">
        <div className="crm-page-body">
          {title ? (
            <div className="crm-card">
              <div className="crm-card-header">
                <h3 className="crm-card-title">{title}</h3>
                {count !== undefined && count !== null && (
                  <div className="crm-badge-counter">Items in list: {count}</div>
                )}
              </div>
              {(toolbarLeft || toolbarRight) && (
                <div className="crm-toolbar">
                  <div className="crm-toolbar-left">{toolbarLeft}</div>
                  <div className="crm-toolbar-right">{toolbarRight}</div>
                </div>
              )}
              {children}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ExhibitorLayout;
